export class PrintReceiptResult {
  isAlreadyPrinted: boolean;
  reloadCurrentInvoice: boolean;
}
